import { render, staticRenderFns } from "./MirrorList.vue?vue&type=template&id=72a45ae3&scoped=true"
import script from "./MirrorList.vue?vue&type=script&lang=js"
export * from "./MirrorList.vue?vue&type=script&lang=js"
import style0 from "./MirrorList.vue?vue&type=style&index=0&id=72a45ae3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a45ae3",
  null
  
)

export default component.exports